import http from '@/utils/http'

export function addApplicationFillingFormRequests(id,data){
    return http.post(`/application_forms/${id}/filling_form_requests`, data)
}
export function addApplicationFinishFillingFormRequests(id,data){
    return http.post(`/application_forms/${id}/finish_filling_form_requests`, data)
}
export function addApplicationFinishUploadFileFillingFormRequests(id,data){
    return http.post(`/application_forms/${id}/finish_upload_file_requests`, data)
}
export function addApplicationSubmitFormRequests(id,data){
    return http.post(`/application_forms/${id}/submit_form_requests`, data)
}
export function addApplicationUploadReceiptRequests(id,data){
    return http.post(`/application_forms/${id}/upload_receipt_requests`, data)
}
export function addApplicationPayRequests(id,data){
    return http.post(`/application_forms/${id}/pay_requests`, data)
}
export function addApplicationCompletePaidRequests(id,data){
    return http.post(`/application_forms/${id}/complete_paid_requests`, data)
}
export function getApplication(params){
    return http('/application_forms',{params})
}
export function addApplication(data){
    return http.post('/application_forms',data)
}
export function getApplicationDetail(id){
    return http(`/application_forms/${id}`)
}

export function deleteApplication(id){
    return http.delete(`/application_forms/${id}`)
}

export function getRequestFromApplications(params){
    return http('/request_from_applications',{params})
}
export function addRequestFromApplications(data){
    return http.post('/request_from_applications',data)
}